import $i18n from 'panda-i18n';
import React, { useContext } from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import { UploadCore } from '@/components/upload-core';
import { UploadContext, UploadStateContext, } from '@/components/upload-core/context';
import { UploadList } from '../upload-list';
import './index.scss';
const View = () => {
    const { value, readOnly, limited } = useContext(UploadStateContext);
    if (readOnly) {
        if (!value.length) {
            return (React.createElement("div", { className: classNames('cn-oss-upload', 'cn-oss-upload-readonly') }, "- -"));
        }
        return (React.createElement("div", { className: classNames('cn-oss-upload', 'cn-oss-upload-readonly') },
            React.createElement(UploadList, null)));
    }
    const text = limited
        ? '已达数量上限'
        : $i18n.get({
            id: 'PleaseUpload',
            dm: '请上传',
            ns: 'CnOssUpload',
        });
    const content = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "cn-ui-m-oss-upload-text" }, text),
        limited ? null : React.createElement(CnIcon, { type: "upload", size: "small" })));
    return (React.createElement("div", { className: classNames('cn-oss-upload', {
            'cn-oss-upload-limited': limited,
        }) },
        React.createElement("div", { className: "cn-ui-m-oss-upload-add" },
            React.createElement(UploadCore, null, content)),
        React.createElement(UploadList, null)));
};
export const OSSUpload = (props) => {
    return (React.createElement(UploadContext, { ...props },
        React.createElement(View, null)));
};
